import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSave, faClose } from "@fortawesome/free-solid-svg-icons"
import Modal from "../../../../components/Modal"

interface EcommerceModalProps {
  isOpen: boolean
  onClose: () => void
  brandId: string
  currentValue: string
  onSave: (brandId: string, value: string) => void
}

const EcommerceModal: React.FC<EcommerceModalProps> = ({
  isOpen,
  onClose,
  brandId,
  currentValue,
  onSave,
}) => {
  const [value, setValue] = useState(currentValue || "")

  const handleSave = () => {
    onSave(brandId, value)
    onClose()
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      handleSave()
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed right-0 top-0 h-full z-50">
      <div className="bg-white h-full w-96 shadow-lg flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4">
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-xl font-semibold">E-Ticaret Altyapısı</h2>
              <p className="text-sm opacity-90 mt-1">Marka ID: {brandId}</p>
            </div>
            <button onClick={onClose} className="text-white hover:text-gray-200">
              ×
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 p-4 overflow-y-auto">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              E-Ticaret Altyapısı
            </label>
            <input
              type="text"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="E-ticaret altyapısını girin..."
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="border-t p-4 bg-gray-50">
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-600">
              {value ? `Mevcut: ${value}` : "Değer girilmemiş"}
            </div>
            <div className="flex gap-2">
              <button
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                İptal
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Kaydet
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EcommerceModal
